// Webpack Imports
import "cookieconsent";

// Test if DNT is enabled in browser
function isDoNotTrackEnabled() {
	const doNotTrackOption =
		window.doNotTrack ||
		window.navigator.doNotTrack ||
		window.navigator.msDoNotTrack;

	if (!doNotTrackOption) {
		return false;
	}

	if (doNotTrackOption.charAt(0) === "1" || doNotTrackOption === "yes") {
		return true;
	}

	return false;
}

// Cookie Consent: Google Analytics is disabled onload (see functions.php)
// https://www.osano.com/cookieconsent/documentation/javascript-api/ and https://github.com/osano/cookieconsent/
const ua = globalData.ua;

function disableCookies() {
	//alert('CC disabled!');
	window["ga-disable-" + ua] = true; // https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out

	$(".ga-disable").css("display", "none");
	$(".ga-status strong").text("disabled");
}

function enableCookies() {
	//alert('CC enabled!');
	window["ga-disable-" + ua] = false; // https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out

	$(".ga-status strong").text("enabled");
}

if (ua && ua.length > 1) {
	window.cookieconsent.initialise({
		theme: "block",
		position: "bottom-left",
		type: "opt-out",
		content: {
			header: globalData.ccHeader,
			message: globalData.ccMessage,
			dismiss: globalData.ccDeny, //globalData.ccDismiss,
			allow: globalData.ccAllow,
			deny: globalData.ccDeny,
			link: globalData.ccLink,
			href: globalData.ccHref,
			close: "&#x274c;",
		},
		onPopupOpen: function () {
			document.body.classList.add("cc");

			if (isDoNotTrackEnabled()) {
				disableCookies();
			} else {
				enableCookies();
			}

			// Consent-Button in Privacy Policy
			/*$( '.ga-disable a' ).on( 'click', function () {
				document.querySelector( '.cc-deny' ).click();
			} );*/
		},
		onPopupClose: function () {
			document.body.classList.remove("cc");
		},
		// https://cookieconsent.insites.com/documentation/disabling-cookies
		onInitialise: function (status) {
			const type = this.options.type,
				didConsent = this.hasConsented();

			if (type == "opt-in" && didConsent) {
				enableCookies();
			}

			if (type == "opt-out" && !didConsent) {
				disableCookies();
			}
		},
		onStatusChange: function (status, chosenBefore) {
			const type = this.options.type,
				didConsent = this.hasConsented();

			if (type == "opt-in" && didConsent) {
				enableCookies();
			}

			if (type == "opt-out" && !didConsent) {
				disableCookies();
			}
		},
	});
}

// Initialize Google Analytics config: see functions.php
window.dataLayer = window.dataLayer || [];
function gtag() {
	dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", ua, { anonymize_ip: true });
